<template lang="pug">
.container
  download
  .layout.p1.m1.border.flex
    .flex-auto.pr1.mr1.border-right.border-color
      .flex.items-start
        .col-8
          swiper(:data="dataCarousel")

          side-bottom-list(:data="dataSideBottom")

        .col-4.pl2
          side-right-list.mt0(:data="dataSide")

      detail-list.border-top.border-color(:data="dataDetail", v-show="dataDetail.length > 0")
      classify-list.border-top.border-color(:data="dataPrimary", :keys="dataPrimaryKeys", :cids="cids", v-show="dataPrimary.length > 0")

    div(style="width: 300px; min-width: 300px")
      admzone
      //- img.mt1.game-rule(src="../assets/image/gameRule.jpg" @click="jumpGame")
      sticky-list(:data="dataSticky")
    //-   RssNews
      AdTrue
</template>
<script>
import _get from 'lodash/get'
import _slice from 'lodash/slice'
import _forEach from 'lodash/forEach'

import arr2chunk from '@/assets/utils/arr2chunk'

// TODO: 侧边固定功能
// import Sticky from 'stickybits'
import Scrollreveal from 'scrollreveal'
import '@/assets/Clamp/clamp'
import swiper from '@/components/Swiper'

import cids from '@/assets/cids'
import sideBottomList from '@/components/sideBottomList'
import sideRightList from '@/components/sideRightList'
import classifyList from '@/components/ClassifyList'
import stickyList from '@/components/StickyList'
import detailList from '@/components/DetailList'
import gameRule from '@/components/GameRule'
import admzone from '@/components/Admzone'
import AdTrue from '@/components/AdTrue'
import RssNews from '@/components/RssNews'
import Download from '@/components/Download'

import '../../node_modules/swiper/dist/css/swiper.css'

export default {
  name: 'home',
  data () {
    return {
      cids: [],

      dataAll: {},
      dataSource: {},
      dataCarousel: {},
      dataSide: {},
      dataSideBottom: {},
      dataSticky: {},
      dataDetail: {},
      dataPrimary: {},
      dataPrimaryKeys: [],

      sr: Scrollreveal({
        reset: false,
        duration: 1200,
        distance: '20px'
      })
    }
  },
  watch: {
    dataSource () {
      this.dataCarousel = _slice(this.dataSource, 0, 3)
      this.dataSideBottom = _slice(this.dataSource, 3, 7)
      this.dataSide = _slice(this.dataSource, 7, 14)
      this.dataSticky = _slice(this.dataSource, 14, 21)

      if (this.isHomePage) {
        this.dataPrimary = arr2chunk.chunkFromValue(this.dataAll)
        this.dataPrimaryKeys = arr2chunk.chunkFromKey(this.dataAll)
        this.dataDetail = []
      } else {
        this.dataDetail = this.isHomePage ? [] : _slice(this.dataSource, 21, 31)
        this.dataPrimary = []
      }
    },
    $route () {
      this.getData()
    }
  },
  computed: {
    cid () {
      return _get(this, '$route.query.id') || 0
    },
    isHomePage () {
      return this.cid === 0
    }
  },
  methods: {
    jumpGame () {
      this.$router.push({path: '/gameRule'})
    },
    switchData () {
      if (this.$route.query.id) {
        this.dataSource = this.dataAll[this.$route.query.id]
      } else {
        this.dataSource = this.dataAll['0'] || this.dataAll[this.cid]
      }
      this.$nextTick(() => {
        this.sr.reveal('.primary-list li')
      })
    },
    getData () {
      let url = this.isHomePage ? '/homepage_data.json' : `/category_${this.$route.query.id}_data.json`
      this.$axios.get(url)
        .then(res => {
          // 过滤无版权文章
          const dataAll = {};
          Object.keys(res.data).forEach(key => {
            dataAll[key] = res.data[key].filter(item => item.pub_source !== 'baotintuc.vn')
          })
          this.dataAll = dataAll
        })
        .then(() => {
          this.switchData()

          this.$nextTick(() => {
            this.setClamp()

            // TODO: 侧边固定功能
            // Sticky(this.$el.querySelector('.sticky-list'))
          })
        })
        .catch(err => {
          this.$router.push('/')
          console.log(err)
        })
    },
    emitCids (cids) {
      this.cids = cids
      this.$bus.emit('getCids', cids)
    },
    setClamp () {
      const clampList = this.$el.querySelectorAll('[data-clamp]')
      _forEach(clampList, el => {
        window.$clamp(el, { clamp: el.getAttribute('data-clamp') })
      })
    }
  },
  mounted () {
    this.getData()
    this.emitCids(cids)
  },
  components: {
    swiper,
    sideBottomList,
    sideRightList,
    classifyList,
    stickyList,
    detailList,
    gameRule,
    admzone,
    RssNews,
    AdTrue,
    Download,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
@import '../assets/variables.styl'

.container
    min-height calc(100vh - 215px)
  .layout
    border-color $color-border
    limit-width()

</style>
<style lang="stylus">
.container
  a
    text-decoration none
    color inherit
.game-rule
  display inline-block
  width 100%
  height auto
</style>



// WEBPACK FOOTER //
// Home.vue?3908f692